import type { UpdateCrbInternalDocumentsRequest } from '@gcv/shared';
import { useMutation } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { useUser } from 'hooks/queries';
import { BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY } from '../../keys';
import { useFiInternalDocumentsCache } from '../useFiInternalDocumentsCache';

export function useUpdateInternalDocuments(dispensaryId: string) {
  const { userBankId } = useUser();
  const dispensariesApi = new DispensariesApi();
  const { updateDocumentsInCache } = useFiInternalDocumentsCache(dispensaryId);

  const { mutate: updateInternalDocuments, isPending: isUpdatingInternalDocuments } = useMutation({
    mutationKey: [BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY],
    mutationFn: (request: UpdateCrbInternalDocumentsRequest) =>
      dispensariesApi.updateInternalDocuments(userBankId, dispensaryId, request),
    onSuccess: (documents) => updateDocumentsInCache(documents),
    meta: {
      snackbarErrorMessage: 'There was an issue updating the documents.'
    }
  });
  return { updateInternalDocuments, isUpdatingInternalDocuments };
}
